<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import dayjs from "dayjs";
    import { eventBus } from '../../../../../../main';

    import StepperHeader from "./BottomSheet/StepperHeader.vue";
    import ActionBar from './BottomSheet/ActionBar.vue';


    export default {
        name: 'BottomSheet',


        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean], // 'showSheet' itself
            editorMode: String, // 'update', 'create', 'extend'
            editorFlightLegMode: String, // 'single', 'rotation'
            eventRecord: Object, // 'update'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-stepper-header': StepperHeader,
            'sdr-stepper-action-bar': ActionBar

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------ 'Form Validation Rules'
                valid : false,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || `Field is required`;
                    },
                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },
                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    },
                    reqIfWeekly(v, flightDateType) {
                        return flightDateType === 0 || v === 0 || (v || '').toString().length > 0 || `Field is required`;
                    },
                    reqIfActiveTab(v, isActiveTab) {
                        return isActiveTab === false || (v || '').toString().length > 0 || `Field is required`;
                    },
                    isFlightNo(v) {
                        return (v === null || v === '' || v === undefined) || /^[a-z]{1,3}\d{1,4}[a-z]{0,1}$/i.test(v) || `Invalid Flight#`
                    }
                },
                // >>> ------------------------------------ 'Form Stepper'
                formStepper: 1,
                // >>> ------------------------------------ 'Stepper Errors'
                validation: { step1: true, step2: true, step3: true },
                activeStepper: '1',
                // >>> ------------------------------------ 'Responsive Element'
                shortHeight: false,
                shortWidth: false,
                // >>> ------------------------------------
                actualChosenYear: '',

            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * get_flights_CrewDetails_SavedPayload{}
            *
            * Desc:
            * Note:
            *
            */
            get_flights_CrewDetails_SavedPayload(v) {

                this.actualChosenYear = dayjs(v.date).format('YYYY');

            }, // eo function get_flights_CrewDetails_SavedPayload()

        },// eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                // >>> --------------------------
                'get_flights_ResourceDetails_ResourceAskedFor',
                'get_flights_CrewDetails_SavedPayload',
            ]),


            /*******************************************************************
            * sheetShown{}
            *
            * Desc:
            * Note:
            *
            */
            sheetShown: {

                get() {
                    const me = this,
                          eventRecord = me.eventRecord;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    if (true === me.value) { // we're opening so initialize data
                        // >>> ------------------ reset validation
                        if(this.$refs.form !== undefined) {
                            this.$refs.form.resetValidation();
                        }
                    }

                    return this.value;

                }, // eo function sheetShown get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/people/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    me.formStepper = 1;
                    this.$emit('input', value);

                }, // eo function sheetShown set()

            }, // eo sheetShown{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* created */
        created: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet.vue >>> created');
            window.addEventListener('resize', this.onEmit_WindowSizeChanged);
            this.onEmit_WindowSizeChanged();

        }, // eo created{}
        /* <<< ****************************************************************/


        /* >>> ***************************************************************** / /* destroyed */
        destroyed: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet.vue >>> destroyed');
            window.removeEventListener('resize', this.onEmit_WindowSizeChanged);

        }, // eo destroyed{}
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                // >>> -------------------------- 'Single Resource Calls'
                'actn_call_getResourcesTrainingsList', // Tab 6
                'actn_call_getResourcesEarlyNightDutiesYearlyList', // Tab 7
                'actn_call_getResourcesReportYearlyList', // Tab 4/3
                'actn_call_getResourcesFlightDutyTimeConfig', // Tab 2
                // >>> --------------------------
                'actn_reset_getCrewDetailsResourceBrief', // Tab
            ]),


            /*******************************************************************
            * Listeners
            *******************************************************************/
            /*******************************************************************
            * onChange_StepperHeader()
            *
            * Desc:
            * Note:
            *
            */
            onChange_StepperHeader: function(stepperNumber) {

                const me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet.vue >>> onChange_StepperHeader');
                me.onClick_StepperHeader(stepperNumber);

            }, // eo function onChange_StepperHeader()


            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Set Tab, Load Tabs Content. Reload.
            * Note:
            * Note: Params (idResource) is added in State itself.
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet.vue >>> onClick_StepperHeader');
                window.dispatchEvent(new Event('resize')); // from Phillip


                switch (stepperNumber) {
                    case '1':
                        break;
                    case '2':
                        if (!Vue.prototype.$isEmpty(this.get_flights_ResourceDetails_ResourceAskedFor.idResource)) {
                            this.actn_call_getResourcesFlightDutyTimeConfig({ year: this.actualChosenYear });
                        }
                        break;
                    case '3':
                        if (!Vue.prototype.$isEmpty(this.get_flights_ResourceDetails_ResourceAskedFor.idResource)) {
                            this.actn_call_getResourcesReportYearlyList({ year: this.actualChosenYear });
                        }
                        break;
                    case '4':
                        if (!Vue.prototype.$isEmpty(this.get_flights_ResourceDetails_ResourceAskedFor.idResource)) {
                            this.actn_call_getResourcesReportYearlyList({ year: this.actualChosenYear });
                        }
                        break;
                    case '5':
                        break;
                    case '6':
                        if (!Vue.prototype.$isEmpty(this.get_flights_ResourceDetails_ResourceAskedFor.idResource)) {
                            this.actn_call_getResourcesTrainingsList();
                        }
                        break;
                    case '7':
                        if (!Vue.prototype.$isEmpty(this.get_flights_ResourceDetails_ResourceAskedFor.idResource)) {
                            this.actn_call_getResourcesEarlyNightDutiesYearlyList({ year: this.actualChosenYear });
                        }
                        break;
                    case '8':
                        break;
                    default:
                        break;
                }


                me.activeStepper = stepperNumber; // set active

            }, // eo function onClick_StepperHeader()


            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            * TODO:: Reset Hier!
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/people/components/core/BottomSheet.vue >>> onClick_CloseSheet');
                me.sheetShown = false;

                eventBus.$emit('resetcrewdetails');
                this.actn_reset_getCrewDetailsResourceBrief();

            }, // eo function onClick_CloseSheet()


            /*******************************************************************
            * onEmit_WindowSizeChanged()
            *
            * Desc:
            *
            */
            onEmit_WindowSizeChanged: function(payload) {

                const me = this;


                if (window.innerHeight <= 1000) {
                    me.shortHeight = true;
                } else {
                    me.shortHeight = false;
                }

                if (window.innerWidth <= 1540) {
                    me.shortWidth = true;
                } else {
                    me.shortWidth = false;
                }

            }, // eo function onEmit_WindowSizeChanged()

        }, // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>

    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        /* max-height:700px; */
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }


    .sdr-custom-tab-active {
        color: #AB3B7A !important;
    }

    .sdr-custom-tabs .v-item-group {
        padding-left: 0;
    }

    @keyframes glowing {
        0% { box-shadow: 0 0 -10px #82A683; transform: scale(1); }
        40% { box-shadow: 0 0 20px #82A683; transform: scale(1.1); }
        60% { box-shadow: 0 0 20px #82A683; transform: scale(1.1); }
        100% { box-shadow: 0 0 -10px #82A683; transform: scale(1); }
    }

    .input-glow {
        animation: glowing 1500ms 1;
    }

</style>

<style>
    /* BottomSheet Wide Classes to get responsibility */
    .smallDisplay .container {
        max-width: 100vw !important;
    }
    /* BottomSheet Wide Classes to get responsibility */

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 70%;
    }

</style>